import angular from 'angular'
import routers from './routers.js'
import financialReportCtrl from './financialReportCtrl.js'

export default angular
    .module('declaration.incomeTax.financialReport', []).config(['$stateProvider', ($stateProvider) => {
        Object.keys(routers).forEach((router) => {
            $stateProvider.state(routers[router].state, routers[router].config)
        })
    }])
    .controller('financialReportCtrl', financialReportCtrl)
    .name



// WEBPACK FOOTER //
// ./src/app/declaration/incomeTax/financialReport/index.js